import { render, staticRenderFns } from "./PageFilters.vue?vue&type=template&id=27d9a666"
import script from "./PageFilters.vue?vue&type=script&lang=js"
export * from "./PageFilters.vue?vue&type=script&lang=js"
import style0 from "./PageFilters.vue?vue&type=style&index=0&id=27d9a666&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports